import $ from 'jquery';

class PreloaderHandler {
    constructor() {
        this.preloader = $('.preloader');
        this.init();
    }

    init() {
        $(document).ready(() => this.fadeOutWithDelay());
    }

    fadeOutWithDelay() {
        setTimeout(() => {
            this.preloader.addClass('fade-out');
        }, 500);
    }
}

export default PreloaderHandler;